import { SC } from "../helper/ServerCall";
import { pathSegment } from "../helper/queryString";

export const programTypeService = {
    storeProgramType,
    getProgramType,
    updateProgramType,
    getProgramTypesPagination,
    deleteProgramType
}

function storeProgramType(data) {
    return SC.postCall(`programType`, data);
}

function getProgramType(id) {
    return SC.getCall(`programType/${pathSegment(id)}`);
}

function updateProgramType(data, id) {
    return SC.putCall(`programType/${pathSegment(id)}`, data);
}

function getProgramTypesPagination(page, filter, sort, pageSize, orderType) {
    return SC.postCall(`getProgramTypesPagination?page=${page}&filter=${filter}&sort=${sort}&pageSize=${pageSize}&orderType=${orderType}`);
}

function deleteProgramType(id) {
    return SC.deleteCall(`programType/${pathSegment(id)}`);
}
